import { render, staticRenderFns } from "./kids_check_new.vue?vue&type=template&id=6119531b&scoped=true&"
import script from "./kids_check_new.vue?vue&type=script&lang=js&"
export * from "./kids_check_new.vue?vue&type=script&lang=js&"
import style0 from "./kids_check_new.vue?vue&type=style&index=0&lang=css&"
import style1 from "./kids_check_new.vue?vue&type=style&index=1&id=6119531b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6119531b",
  null
  
)

export default component.exports